import { useState } from "react";

import {
  ElectronicDocumentDisablement,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_ERROR,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_UPLOADED_TO_SET,
  ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_APPROVED_BY_SET,
} from "../../models/electronic-document-disablement";
import { CCard, CCardBody, CCardHeader, CCollapse } from "@coreui/react";
import DisablementCrudStatus from "./DisablementCrudStatus";
import DisablementCrudActions from "./DisablementCrudActions";
import { DOCUMENT_TYPE_CHOICES } from "../../models/documents";

interface ElectronicDocumentDisablementCardProps {
  disablement: ElectronicDocumentDisablement;
  onUpdateClick: (inv: ElectronicDocumentDisablement) => void;
  onDeleteClick: (inv: ElectronicDocumentDisablement) => void;
}

export function ElectronicDocumentDisablementCard({
  disablement,
  onUpdateClick,
  onDeleteClick,
}: ElectronicDocumentDisablementCardProps) {
  const [open, setOpen] = useState(true);

  const getStatusColor = (status?: string): string => {
    switch (status) {
      case ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_UPLOADED_TO_SET:
        return "warning";
      case ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_ERROR:
        return "danger";
      case ELECTRONIC_DOCUMENT_DISABLEMENT_STATUS_APPROVED_BY_SET:
        return "success";
      default:
        return "info";
    }
  };

  let label = DOCUMENT_TYPE_CHOICES.get(disablement.documentType!);
  if (label === null) {
    label = "-";
  }

  return (
    <CCard className="mb-2">
      <CCardHeader
        className="d-flex justify-content-between align-items-center cursor-pointer"
        onClick={() => setOpen(!open)}
        color={getStatusColor(disablement.status)}
      >
        <span>
          <strong>
            {label}-en{" "}
            {disablement.establishmentCode +
              "-" +
              disablement.dispatchPointIdentifier}
          </strong>
        </span>
        <span className="d-flex align-items-center gap-2">
          <strong>{disablement.from + " al " + disablement.to}</strong>
          <span
            className="rounded-circle bg-white d-flex justify-content-center align-items-center ml-1"
            style={{ width: "22px", height: "22px" }}
          >
            <i
              className={`fa fa-chevron-${open ? "up" : "down"}`}
              style={{ color: "black", fontSize: "12px" }}
            />
          </span>
        </span>
      </CCardHeader>
      <CCollapse show={open}>
        <CCardBody>
          <p>
            <strong>Punto de expedición:</strong>{" "}
            {disablement.establishmentCode +
              "-" +
              disablement.dispatchPointIdentifier}
          </p>
          <p>
            <strong>Rango afectado:</strong>{" "}
            {"Desde " + disablement.from + " al " + disablement.to}
          </p>
          <p>
            <strong>Motivo:</strong> {disablement.reason}
          </p>
          <p>
            <strong>Timbrado Usado:</strong> {disablement.stampIdentifier}
          </p>

          <p>
            <strong>Estado:</strong>{" "}
            <DisablementCrudStatus disbablement={disablement} />
          </p>

          <div>
            <strong>Acciones disponibles:</strong>{" "}
            <DisablementCrudActions
              disablement={disablement}
              onUpdateClick={onUpdateClick}
              onDeleteClick={onDeleteClick}
            />
          </div>
        </CCardBody>
      </CCollapse>
    </CCard>
  );
}
